// Module
var code = "<h2 id=\"confirm-your-action\">Confirm your action!</h2> <p>Please note that disabling your webhook pauses its functionality. You may enable it again by clicking the same toggle.</p> ";
// Exports
module.exports = code;